export const CREDIT_SOURCE_LABELS: Record<string, string> = {
  admin: 'Admin grant', promo_code: 'Promo code', purchase: 'Self-purchased',
  promotional: 'Promotional grant', referral: 'Referral reward', welcome: 'Welcome credits',
  rollover: 'Credit rollover', unknown: 'Unknown source',
};

export function planSourceLabel(plan?: string, source?: string, acquisitionSource?: string): string {
  if (!plan || plan === 'free') return 'Free plan';
  if (acquisitionSource === 'promo_code') return 'Promo code';
  if (source === 'admin') return 'Admin grant';
  if (source === 'revenuecat_purchase' || source === 'stripe_purchase') return 'Self-subscribed';
  if (source === 'revenuecat_promotional') return 'Promotional grant';
  return 'Unknown source';
}

export const SANDBOX_LABEL = 'Sandbox · Test data';
